import RentGuarantee from './RentGuarantee';

import type { RentGuaranteeProps } from './RentGuarantee';

/*
 * NOTE: sync with `modules/analytics/src/types/ClickstreamContextualArgsTypes.ts`
 * to avoid type mismatch for ts-typecheck
 */
export type WebAnalyticsProps = {
  listingAlias: string;
  isApplicationsAccepted: boolean;
  isApplicationsIndicator: boolean;
  isManual: boolean;
  hasNeverBeenActivated: boolean;
  propertyTypeCategory: string;
  eventProductType: string;
  rentGuarantee: RentGuaranteeProps;
};

const WebAnalytics = ({
  listingAlias = '',
  isApplicationsAccepted = false,
  isApplicationsIndicator = false,
  isManual = false,
  hasNeverBeenActivated = false,
  propertyTypeCategory = '',
  eventProductType = '',
  rentGuarantee,
}: Partial<WebAnalyticsProps> = {}): WebAnalyticsProps => ({
  listingAlias: String(listingAlias),
  isApplicationsAccepted: Boolean(isApplicationsAccepted),
  isApplicationsIndicator: Boolean(isApplicationsIndicator),
  isManual: Boolean(isManual),
  hasNeverBeenActivated: Boolean(hasNeverBeenActivated),
  eventProductType: String(eventProductType),
  propertyTypeCategory: String(propertyTypeCategory),
  rentGuarantee: RentGuarantee(rentGuarantee),
});

export default WebAnalytics;
